import { z } from 'zod';
import { requiredReferenceIdSchema } from '@/shared/utils/formZod.schema.utils';

export const diretoriaFormSchema = z
  .object({
    nome: z.string().trim().min(1, 'Informe o nome da diretoria'),
  })
  .passthrough();

export const diretoriaLotacaoFormSchema = z.object({
  defensor: requiredReferenceIdSchema,
  inicio: z.string().trim().min(1, 'Informe a data de início'),
  fim: z.string().trim().optional(),
});

export type DiretoriaFormValues = z.infer<typeof diretoriaFormSchema>;
